import { UnitData, UnitImport, Card, Group } from '../models/unit.models';

import { stateTypes, mutationTypes } from './unit.moduletypes';

const mutations = {
  [mutationTypes.addUnits](state, data) {
    let units = [];
    data.forEach(function(key) {
      units.push(new UnitData(key));
    });
    state[stateTypes.units] = units;
  },
  [mutationTypes.addCurrentUnit](state, data) {
    let currentUnit = new UnitImport(data);
    state[stateTypes.currentUnit] = currentUnit;
  },
  [mutationTypes.addCardToCurrentUnit](state, importData) {
    let { cardData, data } = importData;
    let currentUnit = state[stateTypes.currentUnit];
    currentUnit.groups.forEach((group, index, groups) => {
      if (group.urlGuid == data.groupGuid) {
        cardData.forEach(card => {
          groups[index].cards.push(new Card(card));
        });
      }
    });
  },
  [mutationTypes.deleteCard](state, { groupIndex, cardIndex }) {
    let currentUnit = state[stateTypes.currentUnit];
    currentUnit.groups[groupIndex].cards.splice(cardIndex, 1);
  },
  [mutationTypes.addGroupToCurrentUnit](state, data) {
    let currentUnit = state[stateTypes.currentUnit];
    currentUnit.groups.push(new Group(data));
  },
  [mutationTypes.deleteGroup](state, data) {
    let currentUnit = state[stateTypes.currentUnit];
    currentUnit.groups.splice(data, 1);
  },
  [mutationTypes.moveMachineCard](state, { groupIndex, cardIndex, index }) {
    let currentUnit = state[stateTypes.currentUnit];
    let card = currentUnit.groups[groupIndex].cards.splice(cardIndex, 1);
    currentUnit.groups[index].cards.push(card[0]);
  },
  [mutationTypes.setCurrentMachine](state, data) {
    state[stateTypes.currentMachine] = data;
  },
  [mutationTypes.setCurrentWires](state, data) {
    console.log(data);
  },
  [mutationTypes.setWiresOptionForPosition](state, data) {
    state[stateTypes.wiresOptionForPosition] = data;
  },
  [mutationTypes.setMachinesConfigurations](state, data) {
    state[stateTypes.machinesConfigurations] = data;
  },
  [mutationTypes.setCopyConfiguration](state, data) {
    state[stateTypes.copyConfiguration] = data;
  },
  [mutationTypes.setEasySetup](state, data) {
    state[stateTypes.easySetup] = data;
  }
};

export default mutations;
